import { handlers, config } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.reportingAPI;

async function search(props) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportSchedules/search',
        body: JSON.stringify(props),
      }, API))
  );
}

async function getById(reportScheduleID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/reportSchedules/${reportScheduleID}`
      }, API))
  );
}

async function create(reportSchedule) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportSchedules',
        body: JSON.stringify({ reportSchedule })
      }, API))
  );
}

async function update(reportSchedule) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/reportSchedules/${reportSchedule.reportScheduleID}`,
        body: JSON.stringify({ reportSchedule })
      }, API))
  );
}

async function deleteSchedule(reportScheduleID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/reportSchedules/${reportScheduleID}`
      }, API))
  );
}

const reportScheduleService = {
  search,
  getById,
  create,
  update,
  delete: deleteSchedule
};

export default reportScheduleService;
